import styled from 'styled-components';

export default styled.div`
  .control-wrap {
    background: #ffffff;
    border-radius: 0px 0px 4px 4px;
    border: 1px solid #f6f6f6;
  }
`;
